// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-5 {
  width: 5%;
}

.w-10 {
  width: 10%;
}

.w-15 {
  width: 15%;
}

.w-20 {
  width: 20%;
}

.w-25 {
  width: 25%;
}

.w-30 {
  width: 30%;
}

.w-35 {
  width: 35%;
}

.w-40 {
  width: 40%;
}

.w-45 {
  width: 45%;
}

.w-50 {
  width: 50%;
}

.w-55 {
  width: 55%;
}

.w-60 {
  width: 60%;
}

.w-65 {
  width: 65%;
}

.w-70 {
  width: 70%;
}

.w-75 {
  width: 75%;
}

.w-80 {
  width: 80%;
}

.w-85 {
  width: 85%;
}

.w-90 {
  width: 90%;
}

.w-95 {
  width: 95%;
}

.w-100 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/width.scss"],"names":[],"mappings":"AAAA;EACC,SAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAEA;EACC,WAAA;AACD","sourcesContent":[".w-5 {\n\twidth: 5%;\n}\n\n.w-10 {\n\twidth: 10%;\n}\n\n.w-15 {\n\twidth: 15%;\n}\n\n.w-20 {\n\twidth: 20%;\n}\n\n.w-25 {\n\twidth: 25%;\n}\n\n.w-30 {\n\twidth: 30%;\n}\n\n.w-35 {\n\twidth: 35%;\n}\n\n.w-40 {\n\twidth: 40%;\n}\n\n.w-45 {\n\twidth: 45%;\n}\n\n.w-50 {\n\twidth: 50%;\n}\n\n.w-55 {\n\twidth: 55%;\n}\n\n.w-60 {\n\twidth: 60%;\n}\n\n.w-65 {\n\twidth: 65%;\n}\n\n.w-70 {\n\twidth: 70%;\n}\n\n.w-75 {\n\twidth: 75%;\n}\n\n.w-80 {\n\twidth: 80%;\n}\n\n.w-85 {\n\twidth: 85%;\n}\n\n.w-90 {\n\twidth: 90%;\n}\n\n.w-95 {\n\twidth: 95%;\n}\n\n.w-100 {\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
